var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlux = function SvgFlux(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.521 21.939h-4.253l-4.255-5.957-13.271 18.561h4.264l9.007-12.604h4.254L19.26 34.543h4.274l8.987-12.604L44 37.998 37.284 38v-3.444l-4.762-6.661-4.736 6.65V38H4l20.013-28 8.508 11.94v-.002Z",
    fill: "#000"
  })));
};
export default SvgFlux;